import { Component, OnInit } from '@angular/core';
import { ControlContainer, FormControl, FormGroup } from '@angular/forms';
import { AgenteSituacao } from '@tivic-team/manager-ts/dist/mob';
import { Agente } from '@tivic-team/manager-ts/dist/mob/entities/agente.entity';
import { AgenteSearch } from 'app/services/mob/agente.search';
import { AgenteService } from 'app/services/mob/agente.service';
import { ParentFormGroup } from 'app/tools/parent-formgroup';
import { EMPTY, Observable, from } from 'rxjs';
import { filter, map, mergeMap, tap } from 'rxjs/operators';

@Component({
  selector: 'autocomplete-agente',
  templateUrl: './autocomplete-agente.component.html',
  styleUrls: ['./autocomplete-agente.component.scss'],
  viewProviders: [ParentFormGroup]
})
export class AutocompleteAgenteComponent implements OnInit {
  validate = false;
 
  formGroup: FormGroup;
  agentes: Agente[];
  private _cdAgente: number;

  constructor(
    private _agenteService: AgenteService,
    private _controlContainer: ControlContainer
  ) { }

  ngOnInit() {
    this.formGroup = this._controlContainer.control as FormGroup;
    this.formGroup.addControl('agente', new FormControl());

    this.formGroup.get('agente').valueChanges.pipe(
      filter(keyword => this._validarTexto(keyword)),
      mergeMap(keyword => this._buscar(keyword)),
      tap(agentes => this._finalizarBusca(agentes))
    ).subscribe();
  }

  ngAfterViewInit() {
    this.formGroup.get('cdAgente').valueChanges.pipe(
      mergeMap(cdAgente => this._carregar(cdAgente)),
      tap(agente => this.formGroup.patchValue({agente: agente}, {emitEvent: false})),      
      map(agente => this.agenteSelecionado(agente)),
    ).subscribe();
  }

  agenteSelecionado(agente: Agente) {
    if(!agente) return;

    this._cdAgente = agente.cdAgente;
    this.formGroup.patchValue({ cdAgente: agente.cdAgente }, {emitEvent: false});
    return agente;
  }

  displayNmAgente(agente: Agente) {
    return (agente && agente.nmAgente) || '';
  }

  clear() {
    this.formGroup.reset();
  }

  private _carregar(cdAgente): Observable<Agente>{
    if(!cdAgente || isNaN(cdAgente) || this._cdAgente === cdAgente)
      return EMPTY;

    return from(this._agenteService.get(cdAgente));
  }

  private _validarTexto(keyword: string){
    return keyword && keyword.length > 2;
  }

  private _buscar(keyword: string){
    return from(this._agenteService.find(
      new AgenteSearch({ nmAgente: keyword, stAgente: AgenteSituacao.ATIVO })
    ));
  }

  private _finalizarBusca(resultado: Agente[]){
    this.agentes = resultado
  }

}
